import { businessQuotesService } from '@/services/quotes/business';
import type { BusinessUnderwritingMessagesResponse } from '@/services/quotes/types';
import { useQuery } from '@tanstack/react-query';

export function useUnderwritingMessages(
  policyId: string | undefined,
  enabled = true
) {
  return useQuery<BusinessUnderwritingMessagesResponse>({
    queryKey: ['underwriting-messages', policyId],
    queryFn: async () => {
      if (!policyId) {
        throw new Error('policyId é obrigatório');
      }
      const response = await businessQuotesService.getUnderwritingMessages(
        policyId
      );
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar mensagens de subscrição'
        );
      }
      return response.data;
    },
    enabled: enabled && Boolean(policyId),
  });
}
